const BASE = 'https://bayshoreofficial.directbooking.sg';

const LOGOS = [
  { src: `${BASE}/assets/bt-digital-logo-jhUIUR-Y.png`, alt: 'BT Digital' },
  { src: `${BASE}/assets/straits-times-logo-DP_H9hVG.png`, alt: 'The Straits Times' },
  { src: `${BASE}/assets/99co-CwlZ7BvE.png`, alt: '99.co' },
  { src: `${BASE}/assets/property-guru-DhjgOLwA.png`, alt: 'PropertyGuru' },
  { src: `${BASE}/assets/the-edge-sg-BM7bEWb6.png`, alt: 'The Edge Singapore' },
];

export default function AsSeenOn() {
  return (
    <section className="py-10 md:py-14 bg-[#F8F8F5]">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">
        <div className="flex flex-col items-center gap-5 md:gap-6">
          <p className="text-sm font-semibold text-[#172C37]/60 tracking-wider uppercase">
            As Seen On
          </p>
          <div className="border border-[#172C37]/20 rounded-2xl md:rounded-full px-4 py-5 md:px-12 md:py-7 w-full">
            <div className="flex items-center justify-center gap-6 md:gap-12 flex-wrap">
              {LOGOS.map((logo) => (
                <div key={logo.alt} className="flex items-center justify-center h-7 w-20 md:h-8 md:w-28">
                  <img
                    src={logo.src}
                    alt={logo.alt}
                    className="h-full w-full object-contain grayscale opacity-60 hover:opacity-100 hover:grayscale-0 transition-all duration-300"
                    loading="lazy"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
